import { CONTENT } from "../data/content";
import { ArrowUp } from "lucide-react";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="relative border-t border-border py-12 md:py-16"
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-10 grid grid-cols-1 md:grid-cols-3 gap-8 items-start">
        <div>
          <div className="font-heading font-black text-lg tracking-tight uppercase">
            Madan<span className="text-accent">.</span>Aritakula
          </div>
          <div className="mt-1 font-mono text-[11px] uppercase tracking-[0.22em] text-muted-foreground">
            Cloud Security Engineer · Multi-Cloud
          </div>
        </div>
        <div className="font-mono text-[11px] uppercase tracking-[0.22em] text-muted-foreground space-y-2">
          <div>© {year} — Designed &amp; engineered by Madan.</div>
          <div>Built with React · Tailwind · Framer Motion · Lenis</div>
        </div>
        <div className="md:justify-self-end">
          <button
            data-testid="footer-back-to-top"
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            className="group inline-flex items-center gap-2 border border-border px-4 py-3 font-mono text-[11px] uppercase tracking-[0.22em] hover:border-accent hover:text-accent transition-colors"
          >
            Back to top
            <ArrowUp size={14} className="group-hover:-translate-y-0.5 transition-transform" />
          </button>
        </div>
      </div>
    </footer>
  );
}
